/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GoogleAuthControllerGoogleCallback$Params {
}

export function googleAuthControllerGoogleCallback(http: HttpClient, rootUrl: string, params?: GoogleAuthControllerGoogleCallback$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
'user'?: {
};
}>> {
  const rb = new RequestBuilder(rootUrl, googleAuthControllerGoogleCallback.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'accessToken'?: string;
      'refreshToken'?: string;
      'user'?: {
      };
      }>;
    })
  );
}

googleAuthControllerGoogleCallback.PATH = '/api/oauth/google/callback';
